import { BaseBlock } from "../BaseBlock";

import type { Screen } from "../../app/api/ApiClient";

type ConfirmChangeScreen =
    Extract<Screen, { type: "confirmChange" }>;

export class NewSubscriptionBlock
    extends BaseBlock {

    private readonly subscription:
        ConfirmChangeScreen["new_subscription"];

    constructor(
        screen: ConfirmChangeScreen
    ) {

        super();

        this.subscription =
            screen.new_subscription;

    }

    public override mount(): void {

        super.mount();

        const root =
            document.createElement("section");

        root.className =
            "subscription-card new-subscription-card";

        // =====================================================
        // Заголовок
        // =====================================================

        const caption =
            document.createElement("div");

        caption.className =
            "subscription-card-caption";

        caption.textContent =
            "Нова підписка";

        root.appendChild(
            caption
        );

        // =====================================================
        // Название
        // =====================================================

        const title =
            document.createElement("h2");

        title.className =
            "subscription-card-title";

        title.textContent =
            this.subscription.title;

        root.appendChild(
            title
        );

        // =====================================================
        // Описание
        // =====================================================

        const description =
            document.createElement("div");

        description.className =
            "subscription-card-description";

        description.innerHTML =
            this.subscription.description;

        root.appendChild(
            description
        );

        // =====================================================
        // Начнет действовать
        // =====================================================

        const separator =
            document.createElement("hr");

        separator.className =
            "subscription-card-separator";

        root.appendChild(
            separator
        );

        const startTitle =
            document.createElement("div");

        startTitle.className =
            "subscription-card-label";

        startTitle.textContent =
            "Почне діяти";

        root.appendChild(
            startTitle
        );

        const startValue =
            document.createElement("div");

        startValue.className =
            "subscription-card-value";

        startValue.textContent =
            "після успішної оплати";

        root.appendChild(
            startValue
        );

        // =====================================================
        // Цена
        // =====================================================

        const separator2 =
            document.createElement("hr");

        separator2.className =
            "subscription-card-separator";

        root.appendChild(
            separator2
        );

        const priceTitle =
            document.createElement("div");

        priceTitle.className =
            "subscription-card-label";

        priceTitle.textContent =
            "Ціна";

        root.appendChild(
            priceTitle
        );

        const price =
            document.createElement("div");

        price.className =
            "subscription-card-price";

        if (

            this.subscription.discounted_price_uah
            <
            this.subscription.full_price_uah

        ) {

            const oldPrice =
                document.createElement("span");

            oldPrice.className =
                "old-price-uah";

            oldPrice.textContent =
                `${this.subscription.full_price_uah} грн`;

            price.appendChild(
                oldPrice
            );

            const space =
                document.createTextNode(" ");

            price.appendChild(
                space
            );

        }

        const newPrice =
            document.createElement("span");

        newPrice.className =
            "new-price";

        newPrice.textContent =
            `${this.subscription.discounted_price_uah} грн`;

        price.appendChild(
            newPrice
        );

        root.appendChild(
            price
        );

        this.root = root;

    }

}